import { render } from "./VerifyPhoneNumber.vue?vue&type=template&id=b0a903a8&scoped=true"
import script from "./VerifyPhoneNumber.vue?vue&type=script&lang=js"
export * from "./VerifyPhoneNumber.vue?vue&type=script&lang=js"

import "./VerifyPhoneNumber.vue?vue&type=style&index=0&id=b0a903a8&lang=scss&scoped=true"
import "./VerifyPhoneNumber.vue?vue&type=style&index=1&id=b0a903a8&lang=css"

import exportComponent from "/home/user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0a903a8"]])

export default __exports__